import "./Hero.scss";

import React from "react";

const Hero = () => {
  return (
    <>
      <section className="hero">
            <div className="hero__image"></div>
      </section>
    </>
  );
};

export default Hero;
